var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modals-controller"},[_vm._l((_vm.activeModals),function(modal,idx){return [_c(modal.type,_vm._g(_vm._b({key:idx,tag:"component"},'component',modal.props,false),modal.props))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }